<template>
  <div class="guide-page">
    <div class="guide-title">
      <span class="bold-text">北京市博物馆大数据平台</span>
      <span class="mg-lr-5">已全新升级为</span>
      <span v-if="isMobile" class="bold-text">北京市博物馆智慧管理平台</span>
      <a v-else class="bold-text web-link" href="https://bjmuseum.org.cn/admin" target="_blank">北京市博物馆智慧管理平台</a>
    </div>
    <div class="guide-subtitle">
      <span>公众识别或扫描以下二维码进入</span>
      <span class="bold-text mg-lr-5">北京博物馆云</span>
      <span>小程序，获取最新服务!</span>
    </div>
    <div>
      <img class="qrcode-img" src="../../static/images/qrcode.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  name: "guide",
  data() {
    return {
      isMobile: true
    };
  },
  mounted() {
    this.checkDevice();
  },
  methods: {

    checkDevice() {
      const userAgent = navigator.userAgent;
      const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      this.isMobile = mobileRegex.test(userAgent);
    }
  }
}
</script>

<style lang="scss" scoped>
.guide-page {
  width: 100vw;
  height: 100vh;
  background: url(../../static/images/abc_6.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  font-size: 18px;
  padding: 0 20px;
  box-sizing: border-box;
  line-height: 36px;
  color: #333;

  .guide-title {
    // margin-top: 80px;
  }

  .guide-subtitle {
    margin-top: 30px;
  }

  .bold-text {
    font-weight: 600;
    color: #000;
  }

  .qrcode-img {
    width: 200px;
    height: 200px;
    margin-top: 110px;
  }

  .mg-lr-5 {
    margin: 0 5px;
  }
  .web-link{
      text-decoration: underline;
      color: #000;
      text-underline-offset: 6px;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/index.vue